<template>
	<pre v-html="$t('terms.agreement7')"></pre>
</template>

<script>
export default {
	name: 'Agreement7',
};
</script>

<style scoped></style>
